import React from 'react';
import { useDataFormContext } from '@/context/FormDataContext';
import { stripHtml } from '@/libs/utils';
import { Button } from '@mui/material';
import { MessageContainer, Wrapper, WrapperButtons } from './styles';

interface INonPartnerMessage {
  name: string;
  onContinueClick: () => void
}

/**
 * @param {INonPartnerMessage} props
 * @returns NonPartnerShareMessage component
 */
export default function NonPartnerShareMessage(props:INonPartnerMessage):React.JSX.Element {
  const { blockNonPartnerFlow, setCurrentFormStep, setCurrentFormVariation } = useDataFormContext();
  const safeName = stripHtml(props.name);

  /**
   * @returns asda
   */
  function getMessageText():React.JSX.Element {
    if (blockNonPartnerFlow) {
      return (
        <>
          <p>
            <span>Olá { safeName }, infelizmente não é possível fazer uma proposta por sua cota nesse momento.</span>
          </p>
          <p>
            A Consorciei está constantemente fechando parceria com novas administradoras. Então, assim que for possível
            fazer uma proposta de compra pela sua cota, entraremos em contato por e-mail ou whatsapp.
          </p>
        </>
      );
    } else {
      return (
        <>
          <p>
          Olá { safeName },
          estamos trabalhando para estabelecer uma parceria com sua administradora o mais rápido possível,
          por isso, ainda não conseguimos fazer uma oferta pela sua cota.
          </p>
          <p>
            <span>
              Se quiser receber uma proposta assim que possível,
              é só continuar preenchendo o formulário que a gente entra em contato com você
              assim que finalizarmos o processo de parceria.
            </span>
          </p>
        </>
      );
    }
  }

  return (
    <MessageContainer>
      <Wrapper>
        {getMessageText()}
      </Wrapper>
      {
        !blockNonPartnerFlow && <WrapperButtons>
          <Button
            variant='goFoward'
            onClick={()=>{
              props.onContinueClick();
              window.parent.postMessage(true, '*');
            }}
          >
            Continuar preenchimento
          </Button>
          <Button
            variant='goBack'
            onClick={() => {
              setCurrentFormStep(0);
              setCurrentFormVariation('all');
            }}
          >
          cancelar
          </Button>
        </WrapperButtons>
      }
    </MessageContainer>
  );
}
